export enum CBox_InvoicingBoxComputedMetadataKey {
  LOCKER_FILL_PERCENTAGE = "locker_fill_percentage",
  LOCKER_FILL_PERCENTAGE_ROUNDED = "locker_fill_percentage_rounded",
  LOCKER_DOWNTIME_SECONDS = "locker_downtime_seconds",
  REQUEST_DWELL_SECONDS = "request_dwell_seconds",
  REQUEST_RESERVATION_DWELL_SECONDS = "request_reservation_dwell_seconds",
}

export enum CBox_InvoicingDocumentComputedMetadataKey {
  BOXES_COUNTS_BY_TYPE = "boxes_counts_by_type",
  EXTRA_SERVICES_COUNT = "extra_services_count",
  BOXES_COUNT_PICK_UP_PREVIOUS_MONTH = "boxes_count_pick_up_previous_month",
  BOXES_COUNT_PICK_UP_CURRENT_MONTH = "boxes_count_pick_up_current_month",
  BOXES_COUNT_DROP_OFF_PREVIOUS_MONTH = "boxes_count_drop_off_previous_month",
  BOXES_COUNT_DROP_OFF_CURRENT_MONTH = "boxes_count_drop_off_current_month",
  PICK_UP_REQUEST_REPORTED = "pick_up_request_reported",
  DROP_OFF_REQUEST_REPORTED = "drop_off_request_reported",
  BOXES_COUNT_TOTAL = "boxes_count_total",
}
